import type { BillingStatusView } from 'api';

/**
 * Display de-duplication only (CP-151 §10.2). This module never computes
 * thresholds, bands, or acknowledgement requirements — the backend
 * (`BillingStatusView`) is the single source of truth for those decisions.
 */
export interface BillingNotificationDisplayState {
  periodStartUtc: string;
  notificationLevel: string;
  currentProducts: number;
}

/**
 * Returns whether a notification banner should be (re-)presented for the
 * given status, based purely on whether the (notificationLevel, currentProducts)
 * pair differs from what was last shown for this quarter.
 */
export function shouldPresentNotification(
  status: BillingNotificationDisplayState,
  lastShown: BillingNotificationDisplayState | null,
): boolean {
  if (status.notificationLevel === 'NONE') {
    return false;
  }
  if (lastShown == null || lastShown.periodStartUtc !== status.periodStartUtc) {
    return true;
  }
  return (
    lastShown.notificationLevel !== status.notificationLevel ||
    lastShown.currentProducts !== status.currentProducts
  );
}

export function toDisplayState(status: BillingStatusView): BillingNotificationDisplayState {
  return {
    periodStartUtc: status.periodStartUtc,
    notificationLevel: status.notificationLevel,
    currentProducts: status.currentProducts,
  };
}
